import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: '📘',
  title: 'TOMO 1 — El Modelo de Negocio',
  desc: 'Cómo funciona el arbitraje de gestión en Argentina. Cuánto podés ganar, cómo se estructura el contrato y por qué este es el momento exacto para arrancar.'
}, {
  icon: '📗',
  title: 'TOMO 2 — Captación de Propiedades',
  desc: 'Los 5 canales de prospección para Argentina. El guión exacto de la reunión de 15 minutos. El protocolo de seguimiento de 4 contactos que cierra lo que la reunión no cerró.'
}, {
  icon: '📙',
  title: 'TOMO 3 — El Listado Maestro',
  desc: 'La fórmula para títulos de alto impacto. Descripciones que convierten visitas en reservas. Pricing dinámico sin pagar software. Cómo dominar el algoritmo de Airbnb desde el día 1.'
}, {
  icon: '📕',
  title: 'TOMO 4 — Operaciones y Limpieza',
  desc: 'Check-in autónomo. Protocolo de limpieza estándar. Sistema de laundry. El protocolo de crisis para los 10 incidentes más frecuentes. Tu negocio funciona sin que estés presente.'
}, {
  icon: '📓',
  title: 'TOMO 5 — Customer Service y Reviews',
  desc: 'El sistema de comunicación de 6 etapas con templates listos. Cómo garantizar reseñas de 5 estrellas. La gestión de expectativas que previene el 80% de los problemas.'
}, {
  icon: '📔',
  title: 'TOMO 6 — Finanzas y Cobros en Argentina',
  desc: 'Payoneer vs. Wise vs. dólar MEP. Estructura impositiva para Monotributistas. El reporte mensual de 7 secciones para los dueños. Plan financiero a 12 y 24 meses.'
}];
const includes = ['Plantillas editables para usar de inmediato', 'Guiones y scripts para cada situación', 'Proyecciones adaptadas al mercado argentino', 'Estrategia de cobro en USD desde Argentina', '100% adaptado al contexto económico actual'];
export function ProductBreakdown() {
  return <section className="py-20 bg-white" data-id="element-210">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-211">
        <div className="text-center mb-16" data-id="element-212">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-213">
            📚 6 TOMOS COMPLETOS
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-214">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-surface rounded-2xl p-6 md:p-8 border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-215">
              <div className="text-4xl mb-4" data-id="element-216">{tomo.icon}</div>
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-217">
                {tomo.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm" data-id="element-218">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-8 md:p-12 text-white" data-id="element-219">
          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-220">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-221">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-222">
                <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-223" />
                <span className="text-gray-200 text-sm font-medium" data-id="element-224">
                  {item}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}